<template lang="pug">
  .timer-control
    button.button.is-primary.is-large.is-fullwidth(v-if="member_state == 'break' || member_state == 'absent'" , @click="start(p)")
      .icon
        font-awesome-icon(icon="play")
    .columns.is-mobile(v-else-if="p")
      .column
        button.button.is-warning.is-fullwidth(@click="pause(p)")
          .icon
            font-awesome-icon(icon="pause")
      .column
        button.button.is-danger.is-fullwidth(@click="stop(p)")
          .icon
            font-awesome-icon(icon="stop") 

</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TimerControl",
  props: {
    p: null
  },
  computed: {
    ...mapState(["timer_map"]),
    member_state: function() {
      if (this.p) {
        const m = this.timer_map.get(this.p._id);
        if (m) return m.state;
        else return "absent";
      } else {
        return "absent";
      }
    }
  },

  methods: {
    start(p) {
      this.$store.dispatch("change_state", { user: p, next_state: "working" });
    },
    pause(p) {
      this.$store.dispatch("change_state", { user: p, next_state: "break" });
    },
    stop(p) {
      this.$store.dispatch("change_state", { user: p, next_state: "absent" });
    }
  }
};
</script>

<style scoped lang="less">
</style>
